<template>
  <base-card>
    <div class="text-xs-center pt-3 font-weight-medium">{{ $t('ARTWORK.PAYMENT_OPTIONS_TITLE')}}</div>
    <div class="payment-methods"></div>
  </base-card>
</template>

<script>
export default {
  mounted() {
    console.log("TkPaymentOptions mounted");
    let requestLocale = this.$i18n.locale;
    if (requestLocale === "se") requestLocale = "sv";

    const scriptEl = document.createElement("script");
    scriptEl.setAttribute(
      "src",
      "https://payments.maksuturva.fi/pmt/js/ext/banner/banner.js"
    );
    scriptEl.setAttribute("class", "maksuturva-banner");
    scriptEl.dataset["sellerid"] = "YROWGPZL";
    scriptEl.dataset["maksuturvaHost"] = "https://www.maksuturva.fi";
    scriptEl.dataset["requestLocale"] = requestLocale;
    scriptEl.dataset["topBackgroundColor"] = "#000000";
    scriptEl.onload = () => {
      // NOTE: if Maksuturva event is not working, use that version
      //      const DOMContentLoaded_event = document.createEvent("Event");
      //      DOMContentLoaded_event.initEvent("DOMContentLoaded", true, true);
      //      window.document.dispatchEvent(DOMContentLoaded_event);

      // Maksuturva load event is not working 04.10.2019
      const maksuturvaLoadEvent = document.createEvent("Event");
      maksuturvaLoadEvent.initEvent("maksuturva-load-banner", true, true);
      window.document.dispatchEvent(maksuturvaLoadEvent);
    };

    const cardEl = document.querySelector(".payment-methods");
    cardEl.appendChild(scriptEl);
  },
};
</script>
